import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NotificationBell from '../NotificationBell';
import UserMenu from '../UserMenu';
import { viewTitles, pathToViewId, viewIdToPath } from '../../router/routes';
import useThemePreset from '../../hooks/useThemePreset';
import './GlobalHeader.css';

const PRESET_LABELS = {
  spa: { he: 'ספא', en: 'Spa' },
  clinical: { he: 'קליני', en: 'Clinical' },
  dark: { he: 'כהה', en: 'Dark' },
  contrast: { he: 'ניגודיות גבוהה', en: 'High contrast' },
};

const GlobalHeader = ({
  language = 'he',
  onLanguageToggle,
  onToggleSidebar,
  onProfileClick,
  onPasswordClick,
  onUsersClick,
  onAuditClick,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { preset, cycle } = useThemePreset();

  const currentView = pathToViewId[location.pathname] || 'dashboard';
  const titles = viewTitles[language] || viewTitles.he;
  const pageTitle = titles[currentView] || currentView;

  /** Accepts a view ID (e.g. 'settings') and navigates to its route */
  const handleNavigate = (viewId) => {
    const path = viewIdToPath[viewId] || `/${viewId}`;
    navigate(path);
  };

  return (
    <header className="global-header">
      {/* Mobile hamburger */}
      <button className="header-hamburger" onClick={onToggleSidebar} aria-label="Toggle sidebar">
        <span className="hamburger-line" />
        <span className="hamburger-line" />
        <span className="hamburger-line" />
      </button>

      {/* Page title */}
      <h1 className="header-page-title">{pageTitle}</h1>

      {/* Spacer */}
      <div className="header-spacer" />

      {/* Actions */}
      <div className="header-actions">
        <button
          className="header-theme-toggle"
          onClick={cycle}
          title={`${language === 'he' ? 'ערכת נושא' : 'Theme'}: ${(PRESET_LABELS[preset] || PRESET_LABELS.spa)[language === 'he' ? 'he' : 'en']}`}
          aria-label={language === 'he' ? 'החלף ערכת נושא' : 'Switch theme preset'}
        >
          🎨
        </button>
        <NotificationBell language={language} onViewAll={() => navigate('/notifications')} />
        <button
          className="header-lang-toggle"
          onClick={onLanguageToggle}
          title={language === 'en' ? 'עברית' : 'English'}
        >
          {language === 'en' ? 'עב' : 'EN'}
        </button>
        <UserMenu
          language={language}
          onNavigate={handleNavigate}
          onProfileClick={onProfileClick}
          onPasswordClick={onPasswordClick}
          onUsersClick={onUsersClick}
          onAuditClick={onAuditClick}
        />
      </div>
    </header>
  );
};

export default GlobalHeader;
